import { React, models, kea, history, resources, selectores, componentToRx, Route, match, validation, createSelectorRx, formfields } from "app/main/std";
import { OrigenUsuarioApiList } from "./origen";

type Entity = models.UsuarioApi;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => void;
    onGuardar: () => void;
    nuevo: boolean;
}

/**Vista de la forma para editar un usuarioAPI */
class UsuarioApiFormNoRx extends React.PureComponent<Props>  {
    get rules(): validation.Rules<Entity> {
        const reglas: validation.Rules<Entity> = {
            Nombre: validation.required,
            IdCliente: validation.required,

            IdContenidoPaquete: validation.required,
            IdContenidoSobre: validation.required,
            IdDescripcionPaquete: validation.required,
        }


        return reglas;
    }

    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    render() {
        const getField = this.getField;
        const Text = getField(kea.Text);
        const Cliente = getField(selectores.Cliente);

        const DescripcionPaquete = getField(selectores.DescripcionPaquete);
        const ContenidoPaquete = getField(selectores.ContenidoPaquete);
        const ContenidoSobre = getField(selectores.ContenidoSobre);

        return (
            <div>
                <kea.Title titulo="Usuario API" />
                {kea.autogrid(6, [
                    <Text field="Nombre" />,
                    <Cliente field="IdCliente" label="Cliente" />,
                    <DescripcionPaquete field="IdDescripcionPaquete" label="Descripción paquete" />,
                    <ContenidoPaquete field="IdContenidoPaquete" label="Contenido paquete" />,
                    <ContenidoSobre field="IdContenidoSobre" label="Contenido sobre" />,
                ])}

                {
                    !this.props.nuevo &&
                    <OrigenUsuarioApiList idUsuarioApi={this.props.value.IdRegistro} />
                }

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={this.props.onGuardar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>
        );
    }
}

export const UsuarioApiForm = componentToRx(UsuarioApiFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarioApi/edit/form.tsx